<template>
  <div>

    <v-list three-line v-for="loc in store.state.topLocations" :key="loc.name" class="blue lighten-4">
      <v-list-item class="blue lighten-4 rounded-xl" @click="store.dispatch('openTopLocationDialog', loc)">
        <v-spacer></v-spacer>
        <v-list-item-avatar size="70" >
          <v-img :src="loc.pic_url" lazy-src="~@/assets/alberta-2297204_1920.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title style="white-space: pre-wrap">{{loc.name.split(", ")[0]}}</v-list-item-title>
          <v-list-item-subtitle>{{loc.name.split(", ")[1]}}</v-list-item-subtitle>
          <v-list-item-subtitle>{{loc.nomad_count.toString()}} Nomads</v-list-item-subtitle>
        </v-list-item-content>
        <v-spacer></v-spacer>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
    <!--
        <LocationDialog></LocationDialog>
    -->
  </div>
</template>

<script>
import {store} from "@/store";
/*
import LocationDialog from "@/components/LocationDialog.vue";
*/



export default {
  name: "TopLocations",
  computed: {
    store() {
      return store
    }
  },
  /*
    components: {LocationDialog},
  */
  data() {
    return {
      locationNomads: [],
      dialogLocation: {"locationName":" , "},
      topLocationDialogLocation: {"locationName":" , "},
      dialogVisible: false,
      topLocationDialogVisible: false,
      existingPlace: null,
      userProfileData: {},
      userProfileDepartureDate: null,
    }
  },
  methods: {
    dateRangeText(stayDates) {
      return stayDates.join(' ~ ')
    },
    openDialog(location) {
      this.dialogLocation = location;
      this.dialogVisible = true;
    },
    openProfileCard(user_id, departure_date) {
      let tempUserData = {}
      tempUserData = this.locationNomads.find(user => user.users_data.id === user_id);
      this.userProfileData = tempUserData.users_data
      this.userProfileDepartureDate = departure_date
      store.commit('profileDialogOn')
    },
  },
}
</script>

<style scoped>

</style>
